const api = {
  state: {
    msgTipsShow: false,
    msgContent: "",
  },
};

export default api;
